import React from 'react';
import propTypes from 'prop-types';

import classnames from 'classnames';

const ProgressBar = ({
  className,
  progress,
  text = 'Importing',
}) => (
  <div
    className={classnames('app-progressbar', className)}
    style={{ '--progress': String(progress) }}
  >
    <div className="app-progressbar-text">
      { text } {progress.toFixed(2)}%
    </div>
  </div>
);

ProgressBar.propTypes = {
  progress: propTypes.number.isRequired,
  text: propTypes.string,
  className: propTypes.string,
};

export default ProgressBar;
